'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect, useCallback } from 'react';
import EyesCloseIcon from '../Images/EyesCloseIcon/index.js';
import EyesOpenIcon from '../Images/EyesOpenIcon/index.js';
import RemoveFillIcon from '../Images/RemoveFillIcon/index.js';
import { InputGroupWrapper, LabelWrapper, TextDanger, InputGroup, PrefixIcon, InputWrapper, IconWrapper, InputRecommend, ListRecommend, RecommendItem } from './Input.css.js';
import useFloating from '../hooks/useFloating/index.js';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import { DELAY_TIMEOUT } from './const.js';

var Input = function (props) {
    var onChange = props.onChange, onPressEnter = props.onPressEnter, _a = props.onClickSuggestionItem, onClickSuggestionItem = _a === void 0 ? function (item) { return console.log("".concat(item, " was clicked/selected")); } : _a, value = props.value, _b = props.isRequired, isRequired = _b === void 0 ? false : _b, _c = props.label, label = _c === void 0 ? '' : _c, hasError = props.hasError, listRecommend = props.listRecommend, searchNotFound = props.searchNotFound, _d = props.className, className = _d === void 0 ? '' : _d, _e = props.disabled, disabled = _e === void 0 ? false : _e, _f = props.autoFocus, autoFocus = _f === void 0 ? false : _f, _g = props.clearValue, clearValue = _g === void 0 ? true : _g, icon = props.icon, type = props.type, _h = props.prefixIcon, prefixIcon = _h === void 0 ? null : _h, _j = props.numberFieldRule, numberFieldRule = _j === void 0 ? 'all' : _j, inputRef = props.inputRef, rest = __rest(props, ["onChange", "onPressEnter", "onClickSuggestionItem", "value", "isRequired", "label", "hasError", "listRecommend", "searchNotFound", "className", "disabled", "autoFocus", "clearValue", "icon", "type", "prefixIcon", "numberFieldRule", "inputRef"]);
    var _k = useState(false), isFocus = _k[0], setIsFocus = _k[1];
    var _l = useState(false), showPassword = _l[0], setShowPassword = _l[1];
    var _m = useState(false), isHover = _m[0], setHover = _m[1];
    var inputGroupRef = useRef(null);
    var _o = useFloating({
        placement: 'bottom-start',
        position: 'fixed',
        config: {
            useWindowAsFlippingContainer: true,
            detectHidden: true
        }
    }), context = _o.context, refs = _o.refs, FloatingPortal = _o.FloatingPortal;
    var timer = null;
    var handleClickOnScreen = function (e) {
        timer && clearTimeout(timer);
        timer = setTimeout(function () {
            var _a, _b;
            setIsFocus((_b = (_a = inputGroupRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) !== null && _b !== void 0 ? _b : false);
        }, DELAY_TIMEOUT);
    };
    useEffect(function () {
        // We're using touchend because of some old IOS versions, they're not fired click event, so the handleClickOnScreen func is not worked properly
        window.addEventListener(window.innerWidth < 992 ? 'touchend' : 'click', handleClickOnScreen);
        return function () {
            window.removeEventListener(window.innerWidth < 992 ? 'touchend' : 'click', handleClickOnScreen);
        };
    }, []);
    /**
     * `activeSuggestionIndex`: used to highlight which suggestion is being focused by using up/down key
     */
    var _p = useState(null), activeSuggestionIndex = _p[0], setActiveSuggestionIndex = _p[1];
    var numberOfRecommendedSkills = listRecommend ? listRecommend.length : 0;
    var handleKeyUp = function (event) {
        var _a, _b;
        switch (event.key) {
            case 'ArrowDown': {
                var newIndex = activeSuggestionIndex !== null ? activeSuggestionIndex + 1 : 0;
                if (newIndex >= numberOfRecommendedSkills)
                    newIndex = 0;
                // Set the active item
                setActiveSuggestionIndex(newIndex);
                // Focus on the active item
                var activeItem = refs.popup.current && ((_a = refs.popup.current.querySelectorAll('li')) === null || _a === void 0 ? void 0 : _a[newIndex]);
                activeItem &&
                    activeItem.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'nearest'
                    });
                break;
            }
            case 'ArrowUp': {
                var newIndex = activeSuggestionIndex && activeSuggestionIndex > 0
                    ? activeSuggestionIndex - 1
                    : numberOfRecommendedSkills - 1;
                if (newIndex >= numberOfRecommendedSkills)
                    newIndex = numberOfRecommendedSkills - 1;
                // Set the active item
                setActiveSuggestionIndex(newIndex);
                // Focus on the active item
                var activeItem = refs.popup.current && ((_b = refs.popup.current.querySelectorAll('li')) === null || _b === void 0 ? void 0 : _b[newIndex]);
                activeItem &&
                    activeItem.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'nearest'
                    });
                break;
            }
            case 'Enter': {
                var currentActiveItem = listRecommend === null || listRecommend === void 0 ? void 0 : listRecommend.find(function (_item, index) { return index === activeSuggestionIndex; });
                if (onClickSuggestionItem && currentActiveItem) {
                    onClickSuggestionItem(currentActiveItem);
                    setIsFocus(false);
                    setActiveSuggestionIndex(null);
                }
                break;
            }
        }
    };
    var handleType = useCallback(function () {
        if (type === 'password') {
            if (showPassword)
                return 'text';
            else
                return 'password';
        }
        else if (type) {
            return type;
        }
        else {
            return 'text';
        }
    }, [type, showPassword]);
    var handleOnChange = useCallback(function (e) {
        setActiveSuggestionIndex(null);
        onChange(e.target.value, e);
        setIsFocus(true);
    }, [onChange]);
    var handleOnKeyPress = useCallback(function (e) {
        // If user press `enter` and NOT focusing on the dropdown list
        // We call the input onPressEnter
        if (e.key === 'Enter' && activeSuggestionIndex === null) {
            setIsFocus(false);
            onPressEnter && onPressEnter();
        }
        // If field type is number then
        // numberFieldRule = 'positive-int'
        // positive-int: no negative number, no float and can't be
        if (type === 'number' &&
            numberFieldRule === 'positive-int' &&
            (e.key === 'e' || e.key === 'E' || e.key === '.' || e.key === ',' || e.key === '-' || e.key === '+')) {
            e.preventDefault();
        }
        // numberFieldRule = 'float'
        if (type === 'number' && numberFieldRule === 'float' && (e.key === 'e' || e.key === 'E')) {
            e.preventDefault();
        }
    }, [activeSuggestionIndex, onPressEnter, type]);
    var handleOnClickSuggestItem = useCallback(function (item) {
        if (onClickSuggestionItem) {
            onClickSuggestionItem(item);
            setIsFocus(false);
        }
    }, [onClickSuggestionItem]);
    useCallback(function () {
        if (handleType() === 'password' && !showPassword) {
            return value.replace(/./g, '*');
        }
        return value;
    }, [type, value, showPassword]);
    var handleOnRemoveClick = useCallback(function () {
        var _a, _b;
        onChange('');
        if (inputGroupRef !== undefined && inputGroupRef !== null) {
            (_b = (_a = inputGroupRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [onChange, inputGroupRef]);
    return (React__default.createElement(InputGroupWrapper, { ref: inputGroupRef, isFocus: isFocus, isHover: isHover, isHaveValue: value !== '', isClearValue: clearValue, icon: icon, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } },
        label ? (React__default.createElement(LabelWrapper, null,
            isRequired ? React__default.createElement(TextDanger, null, "*") : null,
            " ",
            React__default.createElement("label", null, label))) : null,
        React__default.createElement(InputGroup, { isClearValue: clearValue, ref: refs.setReference },
            prefixIcon !== null ? React__default.createElement(PrefixIcon, null, prefixIcon) : null,
            React__default.createElement(InputWrapper, __assign({ ref: inputRef, value: value, className: "".concat(className, " class-input-recommend"), onChange: handleOnChange, onKeyPress: handleOnKeyPress, onKeyUp: handleKeyUp, disabled: disabled, autoFocus: autoFocus, type: handleType(), isError: hasError, isHavePrefix: prefixIcon !== null }, rest)),
            icon === 'password' && (React__default.createElement(IconWrapper, { onClick: function () { return setShowPassword(!showPassword); }, onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } }, showPassword ? React__default.createElement(EyesOpenIcon, null) : React__default.createElement(EyesCloseIcon, null))),
            value !== '' ? (React__default.createElement(RemoveFillIcon, { className: "remove-icon ".concat(value && !disabled && clearValue && (isFocus || isHover) ? 'is-show' : 'none'), onClick: function () { return handleOnRemoveClick(); }, onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } })) : null,
            value && listRecommend && isFocus ? (React__default.createElement(FloatingPortal, { enable: true },
                React__default.createElement(InputRecommend, { ref: refs.setPopup, style: {
                        position: context.position,
                        top: context.y,
                        left: context.x,
                        width: refs.reference.current.offsetWidth,
                        zIndex: 1100,
                        display: context.isReferenceHidden ? 'none' : 'block'
                    } },
                    React__default.createElement(ListRecommend, null, listRecommend.length !== 0 ? (listRecommend.map(function (item, index) {
                        return (React__default.createElement(RecommendItem, { isActive: activeSuggestionIndex === index, key: index, onClick: function () { return handleOnClickSuggestItem(item); } }, item.name));
                    })) : (React__default.createElement(RecommendItem, { isEmpty: true }, searchNotFound)))))) : null)));
};

export { Input as default };
//# sourceMappingURL=index.js.map
